const store = {
    namespaced: true,
    state: {
        mainSliders: [],
    },
    getters: {
        getMainSliders: state => state.mainSliders,
    },
    mutations: {
        SET_MAIN_SLIDERS(state, sliders) {
            state.mainSliders = sliders;
        },
    },
    actions: {
        fetchMainSliders: async function ({ commit }, sliderKey) {
            try {
                const { data } = await this.$axios({
                    method: 'get',
                    url: `/general/sliders?key=${sliderKey}`,
                });

                commit('SET_MAIN_SLIDERS', data);
            } catch (e) {
                console.error(e);
                commit('SET_MAIN_SLIDERS', { products: [] });
            }
        },
    },
};

export default store;
